// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f2b3679","455":"ac64cb70","977":"9ecf4ed3"}[chunkId] + ".chunk.js";
};